import type { ListViewSectionControlStrict } from "stores/product";
import type { Section } from "../../ResultingList";

type BuildTitleProps = {
  section: Section;
  values: Record<string, boolean | string | number>;
};

const getLabel = (control: ListViewSectionControlStrict) =>
  control?.keyPresentation || control?.title?.replace(/\s*\(.*?\)/g, "").trim();

export const buildTitle = ({ section, values }: BuildTitleProps) => {
  const isChecked = (id: string) => values[id] === true;

  const isEnabledBy = (enabledBy: string | string[] | null) => {
    if (!enabledBy) return true;

    if (Array.isArray(enabledBy)) {
      return enabledBy.some((id) => values[id] === true);
    }

    return values[enabledBy] === true;
  };

  const sectionGroups = section?.groups || [];

  const [firstGroup, ...restGroups] = sectionGroups;

  const selectedFirst = firstGroup?.controls?.find(
    (c) => c && c.id && isChecked(c.id),
  );
  const firstPart = selectedFirst
    ? (selectedFirst.keyPresentation ?? selectedFirst.title)
    : "";

  const mainTitle = section?.title?.replace(/\(.*?\)/g, "").trim();

  const restParts = restGroups
    ?.map((group) => {
      const selected = group?.controls
        ?.filter(
          (c) =>
            c &&
            c.id &&
            c.enabled &&
            isEnabledBy(c.enabledBy) &&
            isChecked(c.id),
        )
        .map((c) => c && getLabel(c));

      if (!selected?.length) return null;

      return selected.join(", ");
    })
    ?.filter((x): x is string => Boolean(x));

  const restPart = restParts?.length ? `(${restParts.join(" | ")})` : "";

  return [firstPart, mainTitle, restPart]
    .filter(Boolean)
    .join(" ")
    .replace(/\s+\(/, " (");
};

export const checkIsControlEnabled = (
  enabledBy: string | string[] | null,
  values: Record<string, unknown>,
) => {
  if (!enabledBy) return true;

  if (Array.isArray(enabledBy)) {
    return enabledBy.some((id) => values[id] === true);
  }

  return values[enabledBy] === true;
};
